import * as z from "zod";

export const connectTripleWhaleOmsIntegration = {
  name: "connectTripleWhaleOmsIntegration" as const,
  input: z.object({ apiKey: z.string().min(1) }),
  output: z.object({ success: z.boolean() }),
};
